import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@app/hooks/useLanguage';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';
import { getSettingId, readToken } from '@app/services/localStorage.service';
import { Input } from 'antd';
import { notificationController } from '@app/controllers/notificationController';
import { Form } from 'antd';
import { editSetting, getSetting } from '@app/api/settings.api';
import { setLogoTitle, setLogoUrl, setSettingId } from '@app/services/localStorage.service';

export const LogoTitlePicker: React.FC = () => {
  const { t } = useTranslation();
  const uploadUrl =
    process.env.REACT_APP_BASE_URL + '/' + location.pathname.split('/')[1] + '/api/gemba/v0/storage/upload';
  let logoId = '';
  let logoUrl = '';

  const beforeUploadHandle = (file: RcFile) => {
    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    // if (!isJpgOrPng) {
    //   notificationController.error({message: 'You can only upload JPG/PNG file!'});
    // }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      notificationController.error({ message: t('common.validatefileuploadsize') });
    }
    return isLt5M || Upload.LIST_IGNORE;
  };

  const uploadOnChange = (info: any) => {
    if (info.file.status === 'done') {
      console.log('logo uploaded', info.file);

      if (info.file && info.file.response && info.file.response.data) {
        logoId = info.file.response.data.id;
        logoUrl = info.file.response.data.url.replace('10081', '8443');
      }
    } else if (info.file.status === 'error') {
      console.log(`${info.file} file upload failed.`);
      logoId = '';
      logoUrl = '';
    }
  };

  const fileUploadProps = {
    action: uploadUrl,
    onChange: uploadOnChange,
    beforeUpload: beforeUploadHandle,
    headers: { Authorization: 'Bearer ' + readToken() },
    multiple: false,
  };

  const saveLogoTitleSetting = async (values: any) => {
    try {
      const row = values;
      //upload image if change

      const req = {
        id: getSettingId(window.location.pathname.split('/')[1]),
        logoTitle: row.logoTitle ? row.logoTitle : undefined,
        logoImageId: logoId ? logoId : undefined,
        logoImageUrl: logoUrl ? logoUrl : undefined,
      };

      console.log('setting to update ', req);
      await editSetting(req).then((res) => {
        notificationController.success({ message: t('common.success') });
        getSetting().then((respSetting) => {
          console.log('getSetting ===>', respSetting);
          if (respSetting.data) {
            const data = respSetting.data;
            setLogoTitle(data.logoTitle, window.location.pathname.split('/')[1]);
            setLogoUrl(data.logoImageUrl, window.location.pathname.split('/')[1]);
            setSettingId(data.id, window.location.pathname.split('/')[1]);
            window.location.reload();
          }
        });
      });
    } catch (errInfo) {
      console.log('Failed:', errInfo);
    }
  };

  return (
    <Form name="changeLogoForm" onFinish={saveLogoTitleSetting}>
      <Radio.Group>
        {/* <Space direction="vertical"> */}
        <Form.Item name="logoTitle" rules={[{ required: false, message: 'Please input new title!' }]}>
          <Input placeholder="Input new title" />
        </Form.Item>

        <Form.Item>
          <Upload {...fileUploadProps} name="file">
            <Button icon={<UploadOutlined />}>{t('uploads.uploadLogo')}</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button type="primary" style={{ marginTop: 16 }} htmlType="submit">
            {t('common.submit')}
          </Button>
        </Form.Item>
        {/* </Space> */}
      </Radio.Group>
    </Form>
  );
};
